<template>
    <div class="edit-profile-detail">
        <div class="title">결혼 계획</div>
        <div class="section">
            <div class="column">
                <div
                    class="item"
                    :class="{ selected: item.id === selectedIdx }"
                    v-for="item in items"
                    :key="item.id"
                    v-html="item.name"
                    @click="onClickItem(item.id)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import signupConstant from '@/assets/constants/onboard-temp-signup'

export default {
    name: 'MarryPlan',
    computed: {
        tempSignupPayload() {
            return JSON.parse(localStorage.getItem('tempSignupPayload')) || {}
        },
        items() {
            return signupConstant.marryPlan
        },
        disabled() {
            return this.selectedIdx === null
        },
    },
    data: () => ({
        selectedIdx: null,
    }),
    methods: {
        onClickItem(idx) {
            this.selectedIdx = idx

            setTimeout(() => this.next(), 200)
        },
        next() {
            const payload = { ...this.tempSignupPayload, marry_plan: this.selectedIdx }
            localStorage.setItem('tempSignupPayload', JSON.stringify(payload))

            this.$router.push({ name: 'OnboardUseManager' })
        },
    },
    mounted() {
        this.selectedIdx = this.tempSignupPayload.marry_plan
        if (this.tempSignupPayload.marry_plan === undefined) {
            this.$nativeBridge.postMessage({
                action: 'sendFirebaseEvent',
                value: {
                    category: `Enter_MarriagePlanPage`,
                },
            })
        }
    },
}
</script>

<style scoped lang="scss"></style>
